import React, { FunctionComponent, memo } from 'react';
import {
  Grid,
  GridItem,
  Heading,
  PendingContent,
  Space,
  Spinner,
} from 'plume-ui';
import FormattedMessage from '../../../../../../utils/components/FormattedMessage';
import { useFeaturePermission } from '../../../../../../hooks/useFeaturePermission';
import { Permission } from '../../../../../../userPermissionConfig';
import WriteOperationsTopBar from '../../../WriteOperationsTopBar/WriteOperationsTopBar';
import OutreachConfigForm from '../../OutreachConfigForm';
import { Form } from 'formik';
import { PendingContentStyles } from 'plume-ui/dist/components/PendingContent/PendingContent';
import { HeadingStyles } from 'plume-ui/dist/components/Heading/Heading';

export type OutreachFormRendererProps = {
  loadingMetadata: boolean;
  isError: boolean;
  isSubmitting: boolean;
  goBack: () => void;
};

const addStylesToPendingContent = (current: PendingContentStyles) => ({
  ...current,
  root: `${current.root} OutreachContainer__pending-content`,
});

const OutreachFormRenderer: FunctionComponent<OutreachFormRendererProps> = ({
  loadingMetadata,
  goBack,
  isError,
  isSubmitting,
}) => {
  const { hasPermission } = useFeaturePermission();
  const canEditSupportEmail = hasPermission(
    Permission.EditSupportEmailOutreach,
  );
  const canEditSubscriberPush = hasPermission(
    Permission.EditSubscriberPushOutreach,
  );

  const isSubmitDisabled = !canEditSupportEmail && !canEditSubscriberPush;

  return (
    <Form noValidate>
      <WriteOperationsTopBar
        isSubmitDisabled={isSubmitDisabled}
        onSubmit={() => {}}
        onBackClick={goBack}
        isLoading={isSubmitting}
        submitting={isSubmitting}
      />
      <Grid>
        <GridItem colSpan="12" tabletColSpan="12">
          <Heading
            classes={(current: HeadingStyles) => ({
              root: `${current.root} AppLayout__header OutreachContainer__header`,
            })}
            size="xxxxl"
            medium
          >
            <FormattedMessage id="outreach.title" />
          </Heading>
          <Space size="s" />
          <PendingContent
            loading={loadingMetadata}
            hideContent
            isError={isError}
            loader={Spinner}
            classes={addStylesToPendingContent}
          >
            <OutreachConfigForm />
          </PendingContent>
        </GridItem>
      </Grid>
    </Form>
  );
};

export default memo(OutreachFormRenderer);
